


































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { dictServe, performanceServer, safetyAndEnvironmentAssessmentServer } from '@/api/installServer';
import SafetyAndEnvironmentDialog from '@/views/inspectionContents/safetyAndEnvironmentAssessment/unit/safetyAndEnvironmentDialog.vue';

@Component({
  components: { SafetyAndEnvironmentDialog },
})
export default class AssessmentPageComponent extends Vue {
  @Prop(Object) row!: any; // 传递给编辑页面-数据对象
  @Prop(Object) activeName!: any; // 传递给编辑页面-数据对象
  private userData: any = {};
  private titleContent: any = '';
  private cycleUnit: any = '';
  private departmentsOptions: any = []; // 被考核部门列表
  // 表单数据
  formData: any = {
    adjust: null,
    adjustAssessContent: '',
    adjustAssessProject: '',
    adjustAssessPunishMoney: 0,
    adjustAssessScore: 0,
    adjustAssessStand: '',
    adjustAssessStandId: '',
    adjustByAssessDepartmentId: '',
    adjustByAssessDepartmentName: '',
    adjustReason: '',
    adjustVetoConditionFlag: null,
    assessContent: '',
    assessCycleDate: '',
    assessCycleMonth: 0,
    assessCycleSeason: 0,
    assessCycleUnit: '',
    assessCycleYear: 0,
    assessDepartmentId: '',
    assessDepartmentName: '',
    assessProject: '',
    assessPunish: '',
    assessPunishMoney: null,
    assessReason: '',
    assessScore: null,
    assessStaffId: '',
    assessStaffName: '',
    assessStand: '',
    assessStandId: '',
    assessType: '',
    byAssessDepartmentId: '',
    byAssessDepartmentName: '',
    id: '',
    spaceId: '',
    updateFlag: null,
    vetoConditionFlag: null,
    pointsFlag: null,
    adjustPointsFlag: null,
  };

  formRules: any = {};

  // 职务
  assessScoreOptions: any = [
    {
      value: 1,
      label: '加分',
    },
    {
      value: 0,
      label: '扣分',
    },
  ];

  // 周期
  cycleOptions: any = [];
  // 月度周期
  cycleYearOptions: any = [
    {
      name: '一月',
    },
    {
      name: '二月',
    },
    {
      name: '三月',
    },
    {
      name: '四月',
    },
    {
      name: '五月',
    },
    {
      name: '六月',
    },
    {
      name: '七月',
    },
    {
      name: '八月',
    },
    {
      name: '九月',
    },
    {
      name: '十月',
    },
    {
      name: '十一月',
    },
    {
      name: '十二月',
    },
  ];

  // 季度周期
  cycleQuarterOptions: any = [
    {
      name: '第一季度（一月至三月）',
    },
    {
      name: '第二季度（四月至六月）',
    },
    {
      name: '第三季度（七月至九月）',
    },
    {
      name: '第四季度（十月至十二月）',
    },
  ];

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    this.formData.assessType = this.activeName.assessType;
    if (this.activeName.assessCycleUnit === '年度') {
      this.cycleUnit = this.activeName.assessCycleYear + '年度';
    }
    if (this.activeName.assessCycleUnit === '季度') {
      if (this.activeName.assessCycleSeason === 1) {
        this.cycleUnit = this.activeName.assessCycleYear + '年第一季度（一月至三月）';
      }
      if (this.activeName.assessCycleSeason === 2) {
        this.cycleUnit = this.activeName.assessCycleYear + '年第二季度（四月至六月）';
      }
      if (this.activeName.assessCycleSeason === 3) {
        this.cycleUnit = this.activeName.assessCycleYear + '年第三季度（七月至九月）';
      }
      if (this.activeName.assessCycleSeason === 4) {
        this.cycleUnit = this.activeName.assessCycleYear + '年第四季度（十月至十二月）';
      }
    }
    if (this.activeName.assessCycleUnit === '月度') {
      this.cycleUnit = this.activeName.assessCycleYear + '第' + this.activeName.assessCycleMonth + '月度';
    }
    const info: any = localStorage.getItem('userInfo');
    this.userData = JSON.parse(info);
    this.titleContent = this.row ? '编辑扣分明细' : '新增扣分明细'; // 标题
    this.getByDepartments();
  }

  getByDepartments() {
    // 发起接口请求，获取分页数据
    safetyAndEnvironmentAssessmentServer
      .getByDepartments({ assessType: this.activeName.assessType })
      .then((res: any) => {
        this.departmentsOptions = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 检查内容弹窗中所选的数据
   * */
  getData(data: any) {
    if (data) {
      this.formData.assessProject = data.assessProject;
      this.formData.assessContent = data.assessContent;
      this.formData.assessStand = data.assessStand;
    } else {
      this.formData.assessProject = '';
      this.formData.assessContent = '';
      this.formData.assessStand = '';
    }

    this.$forceUpdate();
  }

  changeProject(data: any) {
    if (this.formData.assessType) {
      const safetyDialog = 'safetyDialog';
      const safetyDialogComponent = this.$refs[safetyDialog];
      (safetyDialogComponent as any).showDialog(this.formData.assessType); // 传给弹窗的数据 检查标准项(即 检查内容)
    } else {
      this.$message.warning('请先选择考核类型！');
    }
  }

  assessDepartChange(data: any) {
    if (data) {
      const obj: any = this.departmentsOptions.find((obj: any) => {
        return obj.byDepartmentId === data;
      });
      // console.log(obj);
      this.$nextTick(() => {
        this.formData.byAssessDepartmentName = obj.byDepartmentName;
      });
    } else {
      this.formData.byAssessDepartmentName = '';
    }
  }

  changeAssessType(data: any) {
    this.formData.assessProject = '';
    this.formData.adjustAssessProject = '';
    this.formData.assessContent = '';
    this.formData.adjustAssessContent = '';
    this.formData.assessStand = '';
    this.formData.adjustAssessStand = '';
  }

  getTime() {
    const date = new Date(); //如果date为13位不需要乘1000
    const SY = date.getFullYear();
    const SM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    const SD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    // const Sh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    // const Sm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    // const Ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return SY + '-' + SM + '-' + SD;
  }

  /**
   * @desc 点击取消按钮
   */
  close() {
    this.formData = {};
    this.cycleUnit = '';
    this.$emit('on-response');
  }

  save() {
    this.formData.adjustByAssessDepartmentId = this.formData.byAssessDepartmentId;
    this.formData.adjustByAssessDepartmentName = this.formData.byAssessDepartmentName;
    this.formData.assessDepartmentId = this.userData ? this.userData.deptId : '';
    this.formData.assessDepartmentName = this.userData ? this.userData.deptName : '';
    this.formData.assessStaffId = this.userData ? this.userData.staffId : '';
    this.formData.assessStaffName = this.userData ? this.userData.staffName : '';
    this.formData.spaceId = this.userData ? this.userData.spaceId : '';
    this.addFunctionData();
  }

  /**
   * 【接口】行内新增功能
   */
  private async addFunctionData() {
    this.formData.assessCycleMonth = this.activeName.assessCycleMonth;
    this.formData.assessCycleSeason = this.activeName.assessCycleSeason;
    this.formData.assessCycleUnit = this.activeName.assessCycleUnit;
    this.formData.assessCycleYear = this.activeName.assessCycleYear;
    this.formData.assessCycleDate = this.getTime();
    safetyAndEnvironmentAssessmentServer.addInnerPerformanceData(this.formData).then((res: any) => {
      if (res.code === '200') {
        this.$message.success('添加成功');
        this.close();
      } else {
        this.$message.warning(res.msg);
      }
    });
    // .catch(() => {
    //   this.$message.error('添加失败');
    // });
  }
}
